import { render, staticRenderFns } from "./SaleInvoice.vue?vue&type=template&id=936a08e8&scoped=true"
import script from "./SaleInvoice.vue?vue&type=script&lang=js"
export * from "./SaleInvoice.vue?vue&type=script&lang=js"
import style0 from "./SaleInvoice.vue?vue&type=style&index=0&id=936a08e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936a08e8",
  null
  
)

export default component.exports